import { useDispatch } from 'react-redux';

import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Card,
  CardContent,
  CardHeader,
  Drawer,
  IconButton,
} from '@mui/material';
import { ClassNameMap } from '@mui/styles';
import { closeModal } from '@stores/actions/modal.action';
import { ModalStore } from '@stores/models/store';

interface Props {
  modal: ModalStore;
  classes: ClassNameMap<
    | 'cardContainer'
    | 'closeIcon'
    | 'successIcon'
    | 'modalContainer'
    | 'cardContent'
    | 'confettiWrapper'
  >;
}

const SimpleDrawer = ({ modal, classes }: Props) => {
  const dispatch = useDispatch();

  return (
    <Drawer
      anchor="right"
      open={modal.show}
      onClose={() => dispatch(closeModal())}
    >
      <Card
        elevation={0}
        className={`${modal.className || ''} ${classes.cardContainer}`}
      >
        {modal.withHeader && (
          <CardHeader
            action={
              <IconButton
                aria-label="settings"
                onClick={() => dispatch(closeModal())}
              >
                <FontAwesomeIcon
                  icon={faXmark}
                  size="sm"
                  className={classes.closeIcon}
                />
              </IconButton>
            }
            title={modal.title}
            subheader=""
          />
        )}
        <CardContent className={classes.cardContent}>
          {modal.component}
        </CardContent>
      </Card>
    </Drawer>
  );
};

export default SimpleDrawer;
